import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IContentBlock } from '@core/services/interfaces';
import {
  Content,
  ContentTypeEnum,
  EContentOrder,
  FindContentFilterTemplateEnum,
  FindContentStrategyEnum,
  IFindContentFilter,
  PublishStatusEnum,
} from 'lingo2-models';
import { combineLatest, takeUntil, tap } from 'rxjs';
import { BaseUserProfileSubpageComponent } from '../base-user-profile-subpage.component';

type PublicationsBlock = IContentBlock<Content, IFindContentFilter>;

@Component({
  selector: 'app-user-profile-publications-subpage',
  templateUrl: './user-profile-publications-subpage.component.html',
  styleUrls: ['./user-profile-publications-subpage.component.scss'],
})
export class UserProfilePublicationsSubpageComponent extends BaseUserProfileSubpageComponent implements OnInit {
  @Output() public loaded = new EventEmitter<boolean>();

  public publications: PublicationsBlock = {
    items: [],
    loading: false,
    loaded: false,
    filter: {
      author_id: null,
      use: FindContentStrategyEnum.profile,
      content_type: ContentTypeEnum.microtext,
      template_status: FindContentFilterTemplateEnum.not_template,
      publish_status: [PublishStatusEnum.published],
      order: EContentOrder.date_desc,
    },
    pagination: {
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 1,
    },
  };

  public ngOnInit(): void {
    this.loading = true;
    this.loadingBar.fetchingStart(15);

    combineLatest([this.getMe$, this.getUser$.pipe(tap(() => this.loadPublications()))])
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: () => {
          this.loading = false;
          this.loadingBar.fetchingComplete();
          this.prepareCardByProfile();
          // this.setupMeta();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
          this.loading = false;
          this.loadingBar.fetchingStop();
        },
      });
  }

  protected prepareCardByProfile() {
    this.isMe = this._me && this._user && this._me?.id === this._user.id;
  }

  protected loadPublications(nextPage?: boolean) {
    if (this.publications.loading) {
      return;
    }

    this.publications.loading = true;
    this.loadingBar.fetchingStart(35);
    if (nextPage && this.publications.pagination.page < this.publications.pagination.totalPages) {
      this.publications.pagination.page = this.publications.pagination.page + 1;
    }
    const filter: Partial<IFindContentFilter> = {
      ...this.publications.filter,
      author_id: this._user.id,
    };
    this.contentService
      .getContent(filter, this.publications.pagination)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (response) => {
          if (nextPage) {
            // сбоит this.meetings.items = [ ...this.meetings.items, ...response.results ];
            response.results.map((i) => {
              if (!this.publications.items.find((i1) => i1.id === i.id)) {
                this.publications.items.push(i);
              }
            });
          } else {
            this.publications.items = response.results;
          }
          this.publications.pagination = response.pagination;
          this.publications.loading = false;
          this.publications.loaded = true;
          this.loaded.emit(true);
          this.loadingBar.fetchingComplete();
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
          this.publications.loading = false;
          this.loaded.emit(true);
          this.loadingBar.fetchingStop();
        },
      });
  }

  public onContentPosted() {
    this.loadPublications();
  }

  public onPublicationsNextPage() {
    this.loadPublications(true);
  }

  public trackContentByFn(index, item: Content): string {
    return item.id;
  }
}
